import Nd1SiteNav from "../nd1/components/Nd1SiteNav";

/**
 * Applicant-facing pages shell — shared site nav for every user state.
 */
export default function ApplicantShell({ currentUser, setCurrentUser, children, authToken }) {
  const isApplicant = currentUser?.role === "applicant";
  const rootClass = isApplicant
    ? "nd1-root nd1-root--applicant nd1-applicant-app jw-applicant-page"
    : "nd1-root jw-applicant-page";

  return (
    <div className={rootClass}>
      <Nd1SiteNav />
      {children}
    </div>
  );
}
